import React, {
  useEffect,
  useState
} from 'react';
import {
  useSmartIdLoginMutation,
  useSmartIdStatusMutation,
} from '../../../redux/api';
import {useNavigate} from 'react-router-dom';
import {
  useDispatch,
  useSelector
} from 'react-redux';
import {
  completeSmartIdLogin,
  failSmartIdLogin,
  selectErrorMessage,
  startSmartIdLogin,
} from '../../../redux/slices/smartIdSlice.js';

export const SmartId = () => {
  const navigate = useNavigate();
  const error = useSelector((state) => state.smartId.error);
  const errorMessage = useSelector(selectErrorMessage);
  const [countryCode, setCountryCode] = useState('EE');
  const [personalCode, setPersonalCode] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [smartIdLogin, result] = useSmartIdLoginMutation();
  const [smartIdStatus] = useSmartIdStatusMutation();
  const [errorPersonalCode, setErrorPersonalCode] = useState('');
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (!verificationCode) {
      return undefined;
    }

    let timer;
    let isChecking = true;
    const startTime = Date.now();
    const maxTimeout = 30000;

    const checkVerificationStatus = async () => {
      if (!isChecking) {
        return;
      }

      try {
        const statusResult = await smartIdStatus().unwrap();

        if (statusResult.message === 'Login successful') {
          isChecking = false;
          clearInterval(timer);
          navigate('/logged');
          return;
        }

        if (Date.now() - startTime >= maxTimeout) {
          isChecking = false;
          clearInterval(timer);
          setVerificationCode('');
          dispatch(failSmartIdLogin(statusResult.message || 'Smart-ID autentimine aegus'));
        }
      } catch (statusError) {
        isChecking = false;
        clearInterval(timer);
        setVerificationCode('');
        const message = statusError?.data?.error
          || statusError?.data?.message
          || 'Smart-ID autentimine ebaõnnestus';
        dispatch(failSmartIdLogin(message));
      }
    };

    checkVerificationStatus();
    timer = setInterval(checkVerificationStatus, 5000);

    return () => {
      isChecking = false;
      clearInterval(timer);
    };
  }, [verificationCode, navigate, dispatch, smartIdStatus]);
  
  const handleSmartIdLogin = async () => {
    if (!personalCode) {
      // Handle validation error, e.g., show an error message
      console.log('Isikukood puudub.');

      setErrorPersonalCode('Isikukood puudub.');
      console.log('hello', errorPersonalCode);
      setTimeout(() => {
        setErrorPersonalCode('');
        console.log('Error cleared.');
      }, 5000);
    } else {
      setErrorPersonalCode(''); // Clear the error
      dispatch(startSmartIdLogin());
  
      try {
        const loginData = await smartIdLogin({
          personalCode,
          countryCode,
        }).unwrap();

        dispatch(completeSmartIdLogin(loginData));
        setVerificationCode(loginData.verificationCode);
      } catch (loginError) {
        const message = loginError?.data?.message
          || loginError?.data?.error
          || 'Smart-ID sisselogimise alustamine ebaõnnestus';
        dispatch(failSmartIdLogin(message));
      }
    }
  };
  
  if (result.isLoading) {
    return <div>Laeb...</div>;
  }
  
  return (
    <div className="smart-id-container">
      <div className="verification-container">
        {verificationCode ? (
          <>
            Sinu kontrollkood
            <div className="verification-input">
              <input
                type="text"
                placeholder="Verification Code"
                className="verification-code-input smartIdInput"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
              />
            </div>
            <div>Päring on saadetud Sinu seadmesse.</div>
            <div>Võrdle ja sisesta PIN1</div>
          </>
        ) : (
          <div className="input-section">
            <div className="d-flex align-items-center gap-1">
              <select className="form-select country-select" value={countryCode} onChange={(e) => setCountryCode(e.target.value)}>
                <option value="EE">EE</option>
                <option value="LV">LV</option>
                <option value="LT">LT</option>
              </select>
              <input
                type="text"
                placeholder="Isikukood"
                className="smart-id-input"
                value={personalCode}
                onChange={(e) => setPersonalCode(e.target.value)}
                autoComplete="on"
              />
            </div>
            {errorPersonalCode && <div style={{color: 'red', marginBottom: '-24px'}}>{errorPersonalCode}</div>}
            <br/>
            <button className="smart-id-button mt-3" onClick={handleSmartIdLogin}>
              SISENE
            </button>
          </div>
        )}
        {error && (
          <div className="error-message" style={{color: 'red'}}>
            {errorMessage || 'Viga sisselogimisel'}
            <div style={{color: 'black', marginTop: '16px'}}>
              <div>Puuduvad õigused sisselogimiseks.</div>
              <div>Vajadusel võta ühendust Astro Balticsiga.</div>
              <div
                style={{
                  fontSize: '18px',
                  marginTop: '10px',
                  fontWeight: '600'
                }}
              >
                info@astrobaltics.eu +372 628 0000
              </div>
            </div>
          </div>
        )}
      
      </div>
    </div>
  );
  
};
